export { default } from './ResultsDetail';